import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseFormRef,
  BaseTextContent
} from 'xrk-components';
import { reactive, ref, computed, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'base-insert',
  props: {
    placeholder: {},
    label: {},
    maxlength: {},
    ruleValidator: {},
    type: {},
    disabled: { type: Boolean, default: false },
    rows: { default: 7 },
    defaultValue: {},
    labelPosition: { default: 'top' }
  },
  setup(__props: any, { expose: __expose }) {

const ruleFormRef = ref<BaseFormRef>();
const props = __props;

let formData = reactive<{ data: any }>({
  data: props.defaultValue ? props.defaultValue : ''
});
watch(
  () => formData.data,
  val => {
    if (val == null) {
      formData.data = '';
    }
  }
);
const rulesFrom = computed(() => {
  return [
    {
      required: true,
      validator: props.ruleValidator as (
        rule: any,
        value: any,
        callback: (error?: string | Error) => void
      ) => void,
      trigger: 'change'
    }
  ];
});

__expose({
  getFormData: () => {
    return new Promise((reslve, reject) => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          reslve(formData);
        } else {
          reject('error submit!');
        }
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          "label-position": _ctx.labelPosition,
          "label-width": "200px",
          model: _unref(formData),
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              rules: rulesFrom.value,
              label: _ctx.label,
              prop: "data"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  style: {"width":"100%"},
                  modelValue: _unref(formData).data,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).data) = $event)),
                  maxlength: _ctx.maxlength,
                  "show-word-limit": "",
                  type: _ctx.type,
                  rows: _ctx.rows,
                  placeholder: _ctx.placeholder
                }, null, 8, ["modelValue", "maxlength", "type", "rows", "placeholder"])
              ]),
              _: 1
            }, 8, ["rules", "label"])
          ]),
          _: 1
        }, 8, ["label-position", "model", "disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})